
export const NODE_CATEGORIES = [
  "Message",
  "Question", 
  "Email",
  "Multi-Choice",
  "New Option",
  "AI Mode",
  "Image",
  "Video",
  "Loop",
  "Redirect",
  "Save Data"
];
